<template>
  <div>
    <section class="hero hero-lp hero-mothersday is-clipped has-background-primary">
      <div class="hero-body ">
        <div class="container is-relative">
          <div class="columns pt-5 pb-5 is-vcentered is-variable is-1"
            v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <div class="column is-6-tablet is-5-desktop has-text-centered-mobile titlearea">
              <h1
                class="title has-background-secondary is-inline-block is-size-4 is-size-3-tablet is-size-2-desktop has-text-weight-bold has-text-white pr-1 pl-1 mb-5">
                ADAC Hotelgutschein
              </h1>
              <h2 class="title mothersday-title is-size-3 is-size-2-tablet has-text-weight-bold has-text-black"><span
                  class="is-inline-block-tablet is-block-mobile">Urlaubsfreude </span> <span class="is-inline-block">zum
                  Muttertag</span></h2>
              <!-- <p class="has-text-white-ter has-text-weight-bold is-size-5">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</p> -->
            </div>
            <div class="column has-text-centered">
              <img fetchpriority="high"
                :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=800&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/muttertag.png`"
                alt="Muttertag" width="781" height="326" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile advantages-lp">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>

    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <h2 class="title">Weil die besten Mamas der Welt dieses Jahr mehr als nur eine (R)auszeit verdient haben
            </h2>
            <!-- <h3 class="subtitle has-text-weight-bold">subtitle</h3> -->
            <div class="content">
              <p>
                Mit dem ADAC Hotelgutschein schenken Sie Urlaubsvorfreude, die von Herzen kommt. Denn welche Mama
                wünscht sich dieses Jahr nicht ein paar Tage (R)auszeit vom Alltag?! Wir haben für Sie ein paar
                besondere Hotelangebote zusammengestellt, mit denen es sich vorzüglich von einem
                Wellness-Wochenende an wundervollen Orten fern und nah träumen lässt und reisen Sie, sobald diese wieder
                öffnen dürfen.
              </p>
              <p>
                Mit dem ADAC Hotelgutschein sparen Sie bis zu 70%, die Gutscheine sind flexibel und bis zu 3 Jahre
                einlösbar, sogar übertragbar. Einfach kaufen, ausdrucken und unvergessliche Vorfreude auf Auszeit, Luxus
                und Verwöhnprogramm schenken!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-offers">
      <div class="container">
        <div class="columns" v-if="offers.length == 0">
          <div class="column is-8 is-offset-2">
            <div class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold"
              role="status" aria-live="polite">
              <b-icon icon="sad-cry" size="is-large"></b-icon>
              <br />Leider sind keine Angebote vorhanden!
            </div>
          </div>
        </div>

        <div v-if="offers.length > 0">
          <h2 class="title is-size-4 has-text-centered">Angebote enden in</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <!-- bzw für normale suche haspromotion | Custom:mothersday -->

          <div class="columns is-multiline is-variable is-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--mothersday" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
import OfferApi from '@/api/offer-api'
export default {
  name: 'mothersday',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
  },
  data() {
    return {
      offers: [],
    }
  },
  computed: {
    campaignTimer: function () {
      let endDate = new Date('2021-05-09 23:59') - new Date()
      return endDate
    },
  },
  async mounted() {
    this.offers = await OfferApi.getOffersWithCustomPromotion('muttertag21')
  },
  metaInfo() {
    return {
      title: 'Urlaubsfreude zum Muttertag!',
      meta: [{ name: 'description', content: 'Sichern Sie sich einen ADAC Hotelgutschein zum Muttertag - Ihr Aktiv- & Erholungsurlaub – bis zu 70% günstiger!' }],
      link: [{ rel: 'preconnect', href: '//maps.googleapis.com', crossorigin: 'anonymous' }],
    }
  },
}
</script>

<style lang="scss">
.hero-mothersday {
  .hero-body {
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
}

.mothersday-title {
  line-height: 1;

  @media screen and (min-width: 1024px) {
    font-size: 3rem !important;
  }

  @media screen and (min-width: 1216px) {
    font-size: 3.5rem !important;
  }

  @media screen and (min-width: 1408px) {
    font-size: 4.7rem !important;
  }
}

.offer--mothersday {
  .card-tag .tag {
    background-color: red !important;
  }
}
</style>
